import { YCBConfigArray } from 'Config/types';

/**
 * Configs for any sticker center
 */

export type StickerCentersConfig = {
  prideCenter2023: {
    descriptionKey: string;
  };
};

const stickerCentersConfig: YCBConfigArray<StickerCentersConfig> = [
  {
    settings: ['main'] as const,
    prideCenter2023: {
      descriptionKey: 'PrideCenter.prideStickersDescription',
    },
  },
];

export default stickerCentersConfig;
